let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dSgGr"), load("c5uOY"), load("kIryJ")]).then(() => parcelRequire('j2TUq'));